import { render, staticRenderFns } from "./UsuariosController.vue?vue&type=template&id=0c50b0ac&"
import script from "./UsuariosController.vue?vue&type=script&lang=js&"
export * from "./UsuariosController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports